import React, { useEffect, useState, useCallback } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderBota from "./Header/HeaderBota";
import Sidebar from "./Sidebar/Sidebar";
import ErrorBoundary from "./ErrorBoundary";
import MobileBottomNav from "./MobileBottomNav/MobileBottomNav";

const { Header, Content } = Layout;

const MOBILE_BREAKPOINT = 992;

const headerStyle = {
  color: "#1e293b",
  height: 64,
  lineHeight: "64px",
  backgroundColor: "#FFFFFF",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  zIndex: 1000,
};

export default function Body() {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const checkMobile = useCallback(() => {
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
  }, []);

  useEffect(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [checkMobile]);

  // Auth check done by PrivativeRouterLogin (GET /detail-user); user_token is HttpOnly

  const closeMobileSidebar = useCallback(() => setMobileSidebarOpen(false), []);

  return (
    <div className={`body${isMobile ? " body--mobile" : ""}`}>
      <Layout style={{ height: "100vh", minHeight: 0 }}>
        <Header className="app-header" style={headerStyle}>
          <HeaderBota
            isMobile={isMobile}
            onMenuClick={() => setMobileSidebarOpen(true)}
          />
        </Header>
        <div className="app-main" style={{ display: "flex", flex: 1, overflow: "hidden", minHeight: 0 }}>
          <Sidebar
            collapsed={!isMobile && collapsed}
            onToggleCollapse={() => setCollapsed(!collapsed)}
            isMobile={isMobile}
            mobileOpen={mobileSidebarOpen}
            onMobileClose={closeMobileSidebar}
          />
          <Content
            className="app-content"
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              flex: 1,
              minWidth: 0,
            }}
          >
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Content>
          <MobileBottomNav isMobile={isMobile} />
        </div>
      </Layout>
    </div>
  );
}
